var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionnaires(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Questionnaires",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28808",
    "data-name": "Path 28808",
    d: "M5.25,0H.875A.875.875,0,0,0,0,.875V5.25a.875.875,0,0,0,.875.875H5.25a.875.875,0,0,0,.875-.875V.875A.875.875,0,0,0,5.25,0Zm0,5.25H.875V.875H5.25Z",
    fill: "#474461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28809",
    "data-name": "Path 28809",
    d: "M221.8,0H217.42a.875.875,0,0,0-.875.875V5.25a.875.875,0,0,0,.875.875H221.8a.875.875,0,0,0,.875-.875V.875A.875.875,0,0,0,221.8,0Zm0,5.25H217.42V.875H221.8Z",
    transform: "translate(-208.67)",
    fill: "#474461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28810",
    "data-name": "Path 28810",
    d: "M221.8,216.545H217.42a.875.875,0,0,0-.875.875V221.8a.875.875,0,0,0,.875.875H221.8a.875.875,0,0,0,.875-.875V217.42A.875.875,0,0,0,221.8,216.545Zm0,5.25H217.42V217.42H221.8Z",
    transform: "translate(-208.67 -208.67)",
    fill: "#474461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28811",
    "data-name": "Path 28811",
    d: "M5.25,216.545H.875A.875.875,0,0,0,0,217.42V221.8a.875.875,0,0,0,.875.875H5.25a.875.875,0,0,0,.875-.875V217.42A.875.875,0,0,0,5.25,216.545Zm0,5.25H.875V217.42H5.25Z",
    transform: "translate(0 -208.67)",
    fill: "#474461"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaires);
export default __webpack_public_path__ + "static/media/questionnaires.2c56a0c30a554fa4a8edbec92985f968.svg";
export { ForwardRef as ReactComponent };